export default abstract class Parseable {
    public static parseFromObject(object: any): Parseable {
        throw new Error('Overwrite me!!');
    }

    public static parseFromArray(array: any[]): Parseable[] {
        if (!Array.isArray(array)) {
            return [];
        }
        return array.map((obj) => this.parseFromObject(obj));
    }

    public abstract parseToObject(): any;

    /**
     * Creates a copy based on the parsedFromObject and parsedToObject functions.
     */
    public copy(): Parseable {
        return (this.constructor as any).parseFromObject(this.parseToObject());
    }
}
